<template>
  <div class="itemsContent">
    <div class="content" :style="{ ...position(), transition: animate ? 'all 300ms ease-in-out' : '' }"
         :class="[ curr % 2 ? 'odd' : 'even' ]">
      <div>
        <div>
          <img :alt="items[items.length - 1].url" :src="items[items.length - 1].url"/>
          <h3></h3>
          <p></p>
        </div>
      </div>
      <div v-for="(item, index) in items" :class="focusing(index)">
        <div :style="{ transition: animate ? 'all 300ms ease-in-out' : '' }">
          <img :alt="item.url" :src="item.url"/>
          <h3>{{ item.name }}</h3>
          <p>{{ item.text }}</p>
        </div>
      </div>
      <div v-for="(item, index) in items.slice(0, 3)" :class="focusing(index + items.length)">
        <div :style="{ transition: animate ? 'all 300ms ease-in-out' : '' }">
          <img :alt="item.url" :src="item.url"/>
          <h3>{{ item.name }}</h3>
          <p>{{ item.text }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

let interval = null

export default {
  name: "myCase",
  watch: {
    curr: function (value) {
      if (value < 0) {
        this.curr = 0
      }
      if (value === this.items.length) {
        setTimeout(() => {
          this.animate = false
          this.curr = 0
        }, 300)
        return
      }
      clearInterval(interval)
      interval = setInterval(() => {
        this.curr += 1
      }, this.delay)
    }
  },
  methods: {
    position: function () {
      const css = {
        width: (this.items.length + 4) * 500 + 'px',
        transform: `translateX(-${400 + this.curr * 500}px)`
      }
      setTimeout(() => {
        this.animate = true
      }, 1000)

      return css
    },
    focusing: function (index) {
      return (index === this.curr || index === this.curr + 1) ? 'focus' : ''
    }
  },
  data() {
    return {
      items: [
        {
          url: require('../../assets/image/home/lunbo/haoen.png'),
          name: "豪恩集团",
          text: "专注汽车电子研发、生产与销售",
        },
        {
          url: require('../../assets/image/home/lunbo/suteng.png'),
          name: "速腾聚创",
          text: "全球领先的智能激光雷达系统（Smart LiDAR Sensor System）科技企业",
        },
        {
          url: require('../../assets/image/home/lunbo/huayang.png'),
          name: "华阳通用",
          text: "为客户提供智能产品全方位解决方案的科技集团公司",
        },
        {
          url: require('../../assets/image/home/lunbo/huarong.png'),
          name: "华荣通信",
          text: "华为技术有限公司战略合作伙伴",
        },
        {
          url: require('../../assets/image/home/lunbo/kaifa.png'),
          name: "长城开发",
          text: "全球领先的EMS企业，为全球客户提供制造、供应链、物流等全产业链服务",
        },
        {
          url: require('../../assets/image/home/lunbo/kangyuan.png'),
          name: "康源电子",
          text: "专注于高端PCB和FPC产品的工艺研发、产品制造和销售",
        }
      ],
      curr: 0,
      delay: 3000,
      animate: true
    }
  },
  mounted() {
    interval = setInterval(() => {
      this.curr += 1
    }, this.delay)
  },
  destroyed() {
    clearInterval(interval)
  }
}
</script>

<style scoped>
.itemsContent {
  width: 1200px;
  padding: 20px 0;
  overflow: hidden;
  box-sizing: border-box;
  position: relative;
}

.itemsContent * {
  box-sizing: border-box;
}

.content {
  height: 100%;
  display: flex;
}

.content > div {
  width: 500px;
  height: 100%;
  padding: 15px;
  position: relative;
  transition: all 300ms ease-in-out;
}

.content > div > div {
  height: 100%;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  transform: scale(0.8);
  font-size: 0;
}

.content > div.focus > div {
  transform: scale(1);
  font-size: 12px;
}

img {
  width: 100%;
  margin: 0 0 20px 0;
}

p {
  font-size: 12px;
}
</style>
